import { createSafeContext } from '@mantine/utils';

const [PaginationProvider, usePaginationContext] = createSafeContext("Pagination.Root component was not found in tree");

export { PaginationProvider, usePaginationContext };
//# sourceMappingURL=Pagination.context.js.map
